import { AxiosPromise } from 'axios';
import { IGetCode, IGetCodes, IGetSubcode, IGetSubcodes, ICodeReq, ISubcode, ICodeSeqReq } from '../models/codes.model';
import axios from 'axios';

const uri = '/mgmt/codes';

export const getCommonCodes = (): AxiosPromise<IGetCodes> => {
  return axios.get(uri);
}

export const getCode = (id: string): AxiosPromise<IGetCode> => {
  return axios.get(`${uri}/${id}`);
}

export const getCodes = (): AxiosPromise<IGetCodes> => {
  return axios.get(`${uri}/list`);
}

export const getSubcode = (code: string, id: string): AxiosPromise<IGetSubcode> => {
  return axios.get(`${uri}/${code}/${id}`);
}

export const getSubcodes = (code: string): AxiosPromise<IGetSubcodes> => {
  return axios.get(`${uri}/${code}/list`);
}

export const createCode = (data: ICodeReq): AxiosPromise => {
  return axios.post(uri, data);
};

export const createSubcode = (code: string, data: ISubcode): AxiosPromise => {
  return axios.post(`${uri}/${code}`, data);
};

export const updateCode = (id: string, data: ICodeReq): AxiosPromise => {
  return axios.put(`${uri}/${id}`, data);
};

export const updateSubcode = (code: string, id: string, data: ISubcode): AxiosPromise => {
  return axios.put(`${uri}/${code}/${id}`, data);
};

export const updateSubcodeSeq = (id: string, data: ICodeSeqReq[]): AxiosPromise => {
  return axios.put(`${uri}/${id}/sequence`, data);
};
